export default {
  MODERATION_FINISHED: 'MODERATION_FINISHED',
  INVITE_ANIMATION_FINISHED: 'INVITE_ANIMATION_FINISHED',
  DISMISSED_ALERTING_NOTIFICATION: 'DISMISSED_ALERTING_NOTIFICATION',
  DISMISSED_FIRST_RESPONSE_NOTIFICATION: 'DISMISSED_FIRST_RESPONSE_NOTIFICATION',
  DISMISSED_SECOND_RESPONSE_NOTIFICATION: 'DISMISSED_SECOND_RESPONSE_NOTIFICATION',
  DISMISSED_THIRD_RESPONSE_NOTIFICATION: 'DISMISSED_THIRD_RESPONSE_NOTIFICATION',
  DISMISSED_HIRED_NOTIFICATION: 'DISMISSED_HIRED_NOTIFICATION',
  DISMISSED_RESPONDED_NOTIFICATION_ONE: 'DISMISSED_RESPONDED_NOTIFICATION_ONE',
  DISMISSED_RESPONDED_NOTIFICATION_TWO: 'DISMISSED_RESPONDED_NOTIFICATION_TWO',
  DISMISSED_RESPONDED_NOTIFICATION_THREE: 'DISMISSED_RESPONDED_NOTIFICATION_THREE',
  DISMISSED_APP_UPSELL: 'DISMISSED_APP_UPSELL',
  DISMISSED_NEXT_JOB_UPSELL: 'DISMISSED_NEXT_JOB_UPSELL'
};
